import { ReactElement, ReactNode } from 'react';

import styled from 'styled-components';

import { IconProps } from '@components/icons';
import { Stack } from '@components/stack';
import { theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

export const FilterListItem = ({
  onClick,
  icon,
  label,
  heading = false,
  isActive = false,
  selectionIcon,
}: {
  selectionIcon?: ReactElement<IconProps>;
  icon?: ReactElement<IconProps>;
  label: ReactNode;
  onClick(): void;
  heading?: boolean;
  isActive?: boolean;
}) => {
  return (
    <StyledMenuItem onClick={onClick} $heading={heading} $isActive={isActive}>
      {selectionIcon}
      <Stack space={1} orientation="horizontal" align="center">
        {icon}
        <span>{label}</span>
      </Stack>
    </StyledMenuItem>
  );
};

const StyledMenuItem = styled.li<{ $heading?: boolean; $isActive?: boolean }>((p) => ({
  minHeight: theme.base.height,
  flexShrink: 0,
  font: p.$heading ? theme.font.bold14 : theme.font.regular14,
  textTransform: p.$heading ? 'uppercase' : 'none',
  display: 'flex',
  alignItems: 'center',
  color: p.$isActive ? theme.color.elementBlue100 : theme.color.textPrimary,
  padding: '0.5rem',
  cursor: 'pointer',
  borderRadius: '0.25rem',
  gap: pxToRem(8),

  svg: {
    color: `var(--icon-color, ${theme.color.elementPurpleInvert})`,
    flexShrink: 0,
  },

  '> span': {
    marginLeft: '0.5rem',
    maxWidth: '14rem',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  '&:hover': {
    backgroundColor: theme.color.uiTrans5,
  },
}));
